import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import tr from './locales/tr.json'

/**
 * v1 tek dilli (Türkçe) çalışır, ama tüm metinler baştan katalogdan gelir:
 * bileşenlerde sabit metin yasaktır (docs/standards/frontend-standards.md §7).
 */
export const defaultNS = 'translation'
export const resources = { tr: { translation: tr } } as const

await i18n.use(initReactI18next).init({
  resources,
  lng: 'tr',
  fallbackLng: 'tr',
  defaultNS,
  interpolation: { escapeValue: false },
})

export default i18n
